export default "__VITE_ASSET__9bc4fa21__"